import { ShieldCheck, Cog, Users, Headphones } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const BADGES = [
  { icon: ShieldCheck, label: "Quality Focused" },
  { icon: Cog, label: "Engineering Driven" },
  { icon: Users, label: "Customer Centric" },
  { icon: Headphones, label: "24/7 Support" },
];

export default function Trust() {
  return (
    <section data-testid="trust-section" className="border-y border-slate-200 bg-slate-50 py-20 lg:py-24">
      <div className="mx-auto max-w-5xl px-5 text-center lg:px-8">
        <Reveal>
          <h2 className="font-heading text-3xl font-bold tracking-tight text-navy sm:text-4xl">
            Your Network Deserves Reliable Infrastructure.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mx-auto mt-6 max-w-3xl text-base leading-relaxed text-slate-600 md:text-lg">
            JAYTRIKA focuses on delivering dependable telecom infrastructure, quality
            equipment and practical deployment solutions that help customers build
            stable, scalable and future-ready networks.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            {BADGES.map((b, i) => (
              <span
                key={b.label}
                data-testid={`trust-badge-${i}`}
                className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-5 py-2.5 text-sm font-semibold text-navy shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-blue-300 hover:shadow-md"
              >
                <b.icon size={15} className="text-electric" />
                {b.label}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
